module.exports = __webpack_public_path__ + "img/logo-app-white.d012e38f.svg";